import * as marietta from '../../..';
import { SVGSprite } from '../../flash/display';

export default class DragInputText {
    _firstDot:marietta.core.Point;

    get firstDot() { return this._firstDot; }

    set firstDot(_dot) {
      this._firstDot = _dot;
      this.updateTransforms();
    }

    _secondDot:marietta.core.Point;

    get secondDot() { return this._secondDot; }

    set secondDot(_dot) {
      this._secondDot = _dot;
      this.updateTransforms();
    }

    align:string = 'left';

    minVisibleDistance:number = marietta.webcad.WebCADGlobal.webcad2Dmanager.modulePitch * 0.25;

    public spt:SVGSprite;

    /**
     * コンストラクタ
     * */
    constructor(targetSprite:SVGSprite, id:number) {
      // ラインの作成
      const viewObj:SVGGElement = document.createElementNS('http://www.w3.org/2000/svg', 'text');
      viewObj.setAttribute('class', 'roomDragInputText');
      viewObj.setAttribute('id', `line_text_${id}`);
      viewObj.setAttribute('fill', '#000000');
      viewObj.textContent = '0mm';
      this.spt = new SVGSprite(viewObj);
      targetSprite.addChild(this.spt);
    }

    /**
     * Translateのアップデート
     * @param mmの表示切替
     */
    updateTransforms(mmAppr:boolean = true) {
      if (this.firstDot === undefined || this.secondDot === undefined) return;
      const centerPoint:marietta.core.Point = marietta.core.Point.interpolate(this.firstDot, this.secondDot, 0.5);
      const distance:number = marietta.webcad.util.WebCADUtil.convertPixToMM(marietta.core.Point.distance(this.firstDot, this.secondDot));
      if (mmAppr) {
        this.viewObj.textContent = `${String(Math.round(distance))}mm`;
      } else {
        this.viewObj.textContent = String(Math.round(distance));
      }
      const bound = this.viewObj.getBoundingClientRect();
      const root:SVGSprite = marietta.webcad.WebCADGlobal.layerGroup.spt;
      const sc:number = 1 / root.scaleX;

      switch (this.align) {
        case 'left':
          this.viewObj.setAttribute('x', (centerPoint.x - bound.width * sc - 10).toString());
          this.viewObj.setAttribute('y', (centerPoint.y + (bound.height / 2) * sc).toString());
          break;
        case 'right':
          this.viewObj.setAttribute('x', (centerPoint.x + 10).toString());
          this.viewObj.setAttribute('y', (centerPoint.y + (bound.height / 2) * sc).toString());
          break;
        case 'top':
          this.viewObj.setAttribute('x', (centerPoint.x - (bound.width / 2) * sc).toString());
          this.viewObj.setAttribute('y', (centerPoint.y - bound.height * sc).toString());
          break;
        case 'bottom':
          this.viewObj.setAttribute('x', (centerPoint.x - (bound.width / 2) * sc).toString());
          this.viewObj.setAttribute('y', (centerPoint.y + bound.height * sc + 10).toString());
          break;
        default: break;
      }

      this.spt.visible = this.minVisibleDistance < distance;
      this.spt.update();
    }

    /**
     * HTMLElementの取得
     */
    public get viewObj():HTMLElement {
      return this.spt.element;
    }

    /**
     * 表示ON
     */
    show() {
      this.spt.element.style.visibility = 'visible';
    }

    /**
     * 表示ON
     */
    hide() {
      this.spt.element.style.visibility = 'hidden';
    }
}
